import ChangeHeader from '@/components/shared/table/ChangeHeader'
export var headerMixin = {
    components:{
        ChangeHeader
    },
    data: () => {
        return { 
            changeHeaderDialog: false,
        }
    },
    computed:{
        tableHeaderSelected(){
            return this.tableHeaderAvaiable.filter((header) => {
              return header.show;
            })
          }
    },
    methods:{
        mountHeader(){
            if(localStorage.getItem(this.headerName)){
              let savedHeader = JSON.parse(localStorage.getItem(this.headerName));
              this.tableHeaderAvaiable.forEach((header) => {
                header.show = savedHeader.find((element) => { return element === header.text})
              })
            }
          },                 
    }
}